import type { RelatedPerson } from "@medplum/fhirtypes";
import { RELATED_PERSON_COLLECTION_NAME } from "../../fhir/constants";
import { createSubscriptionHook } from "./create-subscription-hook";

export const useRelatedPersonSubscription = createSubscriptionHook<RelatedPerson>(
  "RelatedPerson",
  RELATED_PERSON_COLLECTION_NAME,
);
